import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Mail, Phone, MapPin, Heart } from 'lucide-react';
import { siteInfo } from '../../data/mock';

const Footer = () => {
  return (
    <footer className="bg-[#3D2E35] text-white">
      {/* Decorative top border */}
      <div className="h-1 bg-gradient-to-r from-[#8B4B7C] via-[#C45B9F] to-[#E8A5C4]" />
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand Column */}
          <div className="lg:col-span-2">
            <div className="mb-6">
              <img 
                src="https://customer-assets.emergentagent.com/job_tevaite-creations/artifacts/btmr9mu6_image.png"
                alt="Tevaite Créations Florales"
                className="h-20 w-auto object-contain brightness-110"
              />
            </div>
            <p className="text-white/70 leading-relaxed mb-6 max-w-md">
              L'art floral tropical au cœur de l'émotion. Des créations uniques inspirées par la beauté des îles du Pacifique.
            </p>
            <div className="flex flex-wrap gap-2">
              {siteInfo.locations.map((loc, index) => (
                <span
                  key={index}
                  className="inline-flex items-center px-3 py-1 rounded-full text-xs bg-white/10 text-white/80"
                >
                  <span className="mr-1">{loc.flag}</span>
                  {loc.name}
                </span>
              ))}
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="font-heading text-lg text-[#E8A5C4] mb-6">Navigation</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-white/70 hover:text-[#E8A5C4] transition-colors duration-300">
                  Accueil
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-white/70 hover:text-[#E8A5C4] transition-colors duration-300">
                  À propos
                </Link>
              </li>
              <li>
                <Link to="/creations" className="text-white/70 hover:text-[#E8A5C4] transition-colors duration-300">
                  Créations
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-white/70 hover:text-[#E8A5C4] transition-colors duration-300">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-white/70 hover:text-[#E8A5C4] transition-colors duration-300">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading text-lg text-[#E8A5C4] mb-6">Contact</h4>
            <ul className="space-y-4">
              <li>
                <a
                  href={`tel:${siteInfo.phone}`}
                  className="flex items-center space-x-3 text-white/70 hover:text-[#E8A5C4] transition-colors duration-300"
                >
                  <Phone size={18} className="text-[#C45B9F]" />
                  <span>{siteInfo.phone}</span>
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${siteInfo.email}`}
                  className="flex items-center space-x-3 text-white/70 hover:text-[#E8A5C4] transition-colors duration-300"
                >
                  <Mail size={18} className="text-[#C45B9F]" />
                  <span>{siteInfo.email}</span>
                </a>
              </li>
              <li>
                <a
                  href="https://instagram.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center space-x-3 text-white/70 hover:text-[#E8A5C4] transition-colors duration-300"
                >
                  <Instagram size={18} className="text-[#C45B9F]" />
                  <span>{siteInfo.instagram}</span>
                </a>
              </li>
              <li className="flex items-start space-x-3 text-white/70">
                <MapPin size={18} className="text-[#C45B9F] mt-1 flex-shrink-0" />
                <span>Polynésie française & International</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-12 pt-8 border-t border-white/10">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-white/50 text-sm flex items-center">
              © {new Date().getFullYear()} Tevaite Création. Fait avec{' '}
              <Heart size={14} className="mx-1 text-[#C45B9F]" fill="currentColor" />
              en Polynésie
            </p>
            <div className="flex items-center space-x-6">
              <Link
                to="/politique-de-confidentialite"
                className="text-white/50 hover:text-[#E8A5C4] transition-colors duration-300 text-sm"
              >
                Politique de confidentialité
              </Link>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white/50 hover:text-[#E8A5C4] transition-colors duration-300"
                aria-label="Instagram"
              >
                <Instagram size={22} />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
